/* eslint-disable unicorn/filename-case */
// TODO: Remove the above line after the ESLint config is fixed.

'use client'; // Error boundaries must be Client Components

import { useEffect, useState } from 'react';

import { i18n } from '../__generated__/i18n';

const GlobalError: React.FC<{ error: Error & { digest?: string }; reset: () => void }> = ({ error }) => {
  const [timestamp] = useState(new Date().toLocaleString());
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div style={{ padding: '16px' }}>
      <div
        style={{
          borderRadius: '8px',
          padding: '16px',
          backgroundColor: '#f8d7da',
          color: '#721c24',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '8px' }}>⚠️</span>
          <strong style={{ display: 'flex', alignItems: 'center' }}>
            {i18n.pages.error.unexpectedError()}
            <span style={{ color: '#6c757d', fontSize: 'small', marginLeft: '8px' }}>({timestamp})</span>
          </strong>
        </div>
        <p>{i18n.pages.error.unexpectedErrorMessage()}</p>
      </div>
    </div>
  );
};

export default GlobalError;
